import React, { Component } from "react";
import { View, Image, TouchableOpacity, FlatList } from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, settingStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor } from "../theme/colors";
import { myfavoritServantRequest } from "../utils/api";
import Waiting from "../components/Waiting";
import FavoritServantItem from "../components/FavoritServantItem";

export default class FavoritExpertScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            favorits: [],
            waiting: true
        }
    }
    _keyExtractor = (item, index) => index.toString();
    renderFavoritRow({ item }) {
        return <FavoritServantItem
            data={item}
            navigation={this.props.navigation}
            islike={true}
            onRefresh={() => {
                this.getData();
            }} />
    }
    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>درمانگران منتخب</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <LinearGradient colors={[blueDarkColor, blueLightColor]} style={settingStyles.wraper}>
                {!this.state.waiting && this.state.favorits.length == 0 ? <TextView style={{ color: 'white' }}>تاکنون درمانگر منتخبی انتخاب نکرده اید</TextView> : null}
                <FlatList
                    data={this.state.favorits}
                    renderItem={this.renderFavoritRow.bind(this)}
                    keyExtractor={this._keyExtractor}
                />
                <TouchableOpacity style={[appStyles.fabIconWraper, { backgroundColor: 'white' }]} activeOpacity={0.5} onPress={() => {
                    this.props.navigation.navigate('addFavoritExpert', {
                        onRefresh: () => {
                            this.getData()
                        }
                    })
                }}>
                    <Image source={icons['add']} style={[appStyles.toolbarIcon, { tintColor: blueDarkColor }]} />
                </TouchableOpacity>
            </LinearGradient>
            <Waiting waiting={this.state.waiting} />
        </View>)
    }

    componentWillMount() {
        this.getData()
    }
    getData() {
        this.setState({
            waiting: true
        })
        myfavoritServantRequest((isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    favorits: response.data
                })
            }
        })
    }

}